<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-btn v-if="_hasPerm('project_add')" color="primary" fab small dark @click="onAddNewClicked">
              <v-icon>add</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-layout row wrap>
              <v-flex sm6></v-flex>
              <v-flex sm6>
                <v-text-field
                  v-model="searchTable"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="desserts"
            :pagination.sync="pagination"
            :total-items="totalDesserts"
            :loading="loading"
            class="elevation-1"
            :rows-per-page-items="$CONFIG.tablePG"
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td>{{ props.item.contract_date }}</td>
                <td>{{ props.item.passport_number }}</td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.mobile }}</td>
                <td>{{ props.item.email }}</td>
                <td>
                  <v-menu offset-y transition="scale-transition">
                    <template v-slot:activator="{ on }">
                      <v-btn flat icon small color="primary" v-on="on">
                        <v-icon dark>more_vert</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-tile
                        v-for="(item, index) in rowActionItems"
                        :key="index"
                        @click="onRowActionItemClicked(item.value, props.item)"
                      >
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </template>
            <template slot="no-data">
              <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- <v-btn fab bottom right color="pink" dark fixed @click.stop="productsAddModal=true;">
      <v-icon>add</v-icon>
    </v-btn>-->

    <v-dialog v-model="isAddFormModal" scrollable persistent max-width="900px">
      <AddForm
        :agents="agents"
        :employers="employers"
        @cancelled="isAddFormModal = false"
        @added="getDataFromApi"
      />
    </v-dialog>
    <v-dialog v-model="isEditFormModal" scrollable persistent max-width="900px">
      <EditForm
        :agents="agents"
        :employers="employers"
        @cancelled="isEditFormModal = false"
        :edit-item="editItem"
      />
    </v-dialog>
    <v-dialog v-model="isDetailsModal" scrollable persistent max-width="900px">
      <DetailsView
        @cancelled="isDetailsModal = false"
        :item="editItem"
        :details="projectDetais"
        @paymentAdded="onPaymentAdded"
        @reload="loadProjectDetails"
      />
    </v-dialog>
  </div>
</template>

<script>
import Nl2br from "vue-nl2br";
import AddForm from "./ProjectAdd.vue";
import EditForm from "./ProjectEdit.vue";
import DetailsView from "./ProjectDetails.vue";

export default {
  components: {
    Nl2br,
    AddForm,
    EditForm,
    DetailsView,
  },
  data: () => ({
    actionButtonClicked: false,

    headers: [
      { text: "Contract Date", value: "contract_date" },
      { text: "Passport", value: "passport_number" },
      { text: "Candidate Name", value: "name" },
      { text: "Mobile", value: "mobile" },
      { text: "Email", value: "email" },
      { text: "Actions", value: "name", sortable: false },
    ],

    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {
      sortBy:'contract_date',
      descending: true
    },
    getApiaParams: {
      fields: 'id,agent_id,contract_date,applied_country,profession,name,father_name,mother_name,present_district,present_upazila,present_union,present_village,permanent_district,permanent_upazila,permanent_union,permanent_village,passport_number,passport_issue_date,passport_exp_date,dob,age,nid_number,birth_cert_number,nationality,gender,religion,marital_status,height,weight,language_proficiency,educational_qualification,working_experience,working_experience_type,mobile,family_mobile_number,notes',
      search_fields: "id,name,mobile,email,contract_date,passport_number,notes",
    },
    searchTable: "",

    rowActionItems: [
      { title: "View Details", value: "details" },
      { title: "Edit", value: "edit" },
      { title: "Delete", value: "delete" },
    ],

    isAddFormModal: false,
    isEditFormModal: false,
    isDetailsModal: false,
    editItem: {},

    agents: [],
    employers: [],
    projectDetais: {},

    selectedItem: {}

    // isPatientPrescriptionsModal: false,
    // selectedPatient: {},
    // patientPrescriptions: [],
    // patientPrescription: {},
    // patientPrescriptionDetails: {},
    // isPreviewPrescripiton: false,
  }),

  computed: {},

  watch: {
    pagination: {
      handler() {
        this.getDataFromApi();
      },
      deep: true,
    },
    searchTable: {
      handler() {
        this.getDataFromApi();
      },
      deep: true,
    },
  },

  created() {},

  mounted() {},

  methods: {
    getDataFromApi() {
      this.loading = true;
      const { sortBy, descending, page, rowsPerPage } = this.pagination;

      if (sortBy == null) {
        delete this.getApiaParams.sort;
      } else {
        this.getApiaParams.sort = descending ? "-" + sortBy : "+" + sortBy;
      }
      this.getApiaParams.limit = rowsPerPage;
      this.getApiaParams.offset = (page - 1) * rowsPerPage;
      this.getApiaParams.search = this.searchTable;

      this.get("/projects", this.getApiaParams).then((response) => {
        this.desserts = response.data.data.items;
        this.totalDesserts = response.data.data.total_items;
        this.loading = false;
      });
    },
    async loadFormData() {
      const agentRes = await this.get("/agents");
      this.agents = agentRes.data.data;
      const employerRes = await this.get("/employers");
      this.employers = employerRes.data.data;
    },
    onAddNewClicked() {
      this.isAddFormModal = true;
      this.loadFormData();
    },
    onEditClicked(item) {
      this.editItem = item;
      this.isEditFormModal = true;
      this.loadFormData();
    },
    onDetailsClicked(item) {
      this.editItem = item;
      this.isDetailsModal = true;
      this.loadProjectDetails();
    },
    async loadProjectDetails() {
      const { id } = this.selectedItem;
      const projectRes = await this.get(`/project_details/${id}`);
      this.projectDetais = projectRes.data;
    },

    onPaymentAdded(addedData){
      // console.log('addedData:', addedData);
      this.loadProjectDetails();
    },

    onRowActionItemClicked(action, item) {
      this.selectedItem = item;
      switch (action) {
        case "details":
          this.onDetailsClicked(item);
          break;
        case "edit":
          this.onEditClicked(item);
          break;
        case "delete":
          this.$confirm("Do you really want to DELETE project ?").then((isConfirmed) => {
            if (isConfirmed) {
              this.$http.delete("/project/" + item.id).then((res) => {
                if (res.data.success) {
                  this.desserts = this.desserts.filter((row) => row.id != item.id);
                }
                this.snackbarShow(res.data);
              });
            }
          });
          break;
      }
    },
  },

  beforeDestroy() {},
};
</script>
